import { configureStore } from '@reduxjs/toolkit'
import studioReducer from './studio/index'
import undoable from './undoable'
import {
    itemAdded,
    itemMoved,
    itemResized,
    itemDeleted,
    itemDuplicated,
    itemRotated,
    responsiveModeToggled,
    itemSelected,
    itemDeselected,
    zoomIn,
    zoomOut,
    zoomTo,
    bringForward,
    sendBackward,
    updateItem,
} from './studio/index'
import assetsReducer from './platformAsset/slice'
import activeToolReducer from './studio/activeToolSlice'
import gridReducer from './studio/gridSlice'

const undoableStudioReducer = undoable(studioReducer, {
    filter: (action) => {
        if (
            [
                zoomIn.type,
                zoomOut.type,
                zoomTo.type,
                itemSelected.type,
                itemDeselected.type,
            ].includes(action.type as any)
        ) {
            return false
        }

        return [
            itemAdded.type,
            itemMoved.type,
            itemResized.type,
            itemDeleted.type,
            updateItem.type,
            itemDuplicated.type,
            itemRotated.type,
            responsiveModeToggled.type,
            bringForward.type,
            sendBackward.type,
        ].includes(action.type as any)
    },
})

export const store = configureStore({
    reducer: {
        studio: undoableStudioReducer,
        assets: assetsReducer,
        activeTool: activeToolReducer,
        studioGrid: gridReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
